import { render } from "./NavigationButton.vue?vue&type=template&id=7ffb0fa6"
import script from "./NavigationButton.vue?vue&type=script&lang=js"
export * from "./NavigationButton.vue?vue&type=script&lang=js"

import "./NavigationButton.vue?vue&type=style&index=0&id=7ffb0fa6&lang=css"

import exportComponent from "/Users/macbookair/Documents/Software Chelita/BAESA/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__